import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/warning-orange-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5d2bda78"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "data-cy"]
const _hoisted_2 = { class: "tw-grid tw-grid-cols-5 gap-3" }
const _hoisted_3 = { class: "tw-col-span-5 md:tw-col-span-3 xl:tw-col-span-4" }
const _hoisted_4 = {
  class: "tw-flex tw-gap-[15px] tw-w-full",
  "data-cy": "main-question"
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-items-center tw-justify-start tw-gap-[15px] tw-h-[fit-content] tw-mt-[2px]`)
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-flex-col tw-gap-[20px] tw-w-full questionWrapper`),
  "data-cy": "question-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "prefilled"
}
const _hoisted_8 = { class: "tw-flex tw-justify-between" }
const _hoisted_9 = { class: "tw-flex tw-gap-[15px]" }
const _hoisted_10 = { class: "tw-flex tw-items-center" }
const _hoisted_11 = ["id", "data-id"]
const _hoisted_12 = {
  key: 0,
  class: "info-icon tw-ml-[15px] md:tw-ml-[25px]"
}
const _hoisted_13 = {
  key: 0,
  class: "tw-p-[15px] tw-w-[475px]"
}
const _hoisted_14 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_19 = {
  key: 0,
  class: "prefilled"
}
const _hoisted_20 = {
  key: 1,
  class: "tw-flex tw-w-fit tw-max-w-[965px] tw-items-center tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-item-center tw-w-[16px] tw-h-[16px] tw-mr-[10px]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_22 = ["data-cy"]
const _hoisted_23 = ["id"]
const _hoisted_24 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-gap-[20px] additionalInfo tw-flex-col tw-items-start`)
}
const _hoisted_25 = { class: "tw-col-span-5 md:tw-col-span-2 xl:tw-col-span-1" }
const _hoisted_26 = { class: "tw-flex tw-flex-col tw-gap-[20px] tw-items-end tw-justify-center tw-h-full" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8741 6.38894L6.38429 0.165448C6.33485 0.113191 6.27527 0.0715663 6.2092 0.0431191C6.14312 0.0146718 6.07194 -2.59124e-07 6 -2.62268e-07C5.92806 -2.65413e-07 5.85688 0.0146718 5.7908 0.0431191C5.72473 0.0715663 5.66515 0.113191 5.61571 0.165448L0.125859 6.38894C0.081969 6.43838 0.0483386 6.49604 0.02692 6.55858C0.00550146 6.62113 -0.00327902 6.6873 0.00108975 6.75327C0.0065009 6.81976 0.0251891 6.8845 0.056049 6.94364C0.086909 7.00279 0.129313 7.05515 0.180757 7.09763L1.10405 7.8712C1.15449 7.91483 1.21315 7.9479 1.27658 7.96848C1.34002 7.98905 1.40693 7.9967 1.47337 7.99098C1.53949 7.9862 1.604 7.96828 1.66313 7.93829C1.72225 7.9083 1.77481 7.86683 1.81773 7.8163L5.91516 3.10002C5.94039 3.07503 5.97447 3.06101 6.00998 3.06101C6.04549 3.06101 6.07957 3.07503 6.10481 3.10002L10.1823 7.8163C10.2629 7.91267 10.377 7.97505 10.5017 7.99098C10.5678 7.99738 10.6345 7.99052 10.6979 7.97081C10.7613 7.9511 10.8202 7.91893 10.871 7.87619L11.8192 7.09763C11.8707 7.05515 11.9131 7.00279 11.9439 6.94364C11.9748 6.8845 11.9935 6.81976 11.9989 6.75327C12.0033 6.6873 11.9945 6.62113 11.9731 6.55859C11.9517 6.49604 11.918 6.43838 11.8741 6.38894Z",
  fill: "#DBDBDB"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-items-center tw-justify-end tw tw-w-[100%] tw-gap-[20px]`)
}
const _hoisted_30 = {
  key: 0,
  class: "tw-flex tw-gap-[20px] tw-items-center others"
}
const _hoisted_31 = { class: "tw-flex tw-w-[102px] tw-justify-center tw-gap-[10px] tw-h-[fit-content] tw-pt-[8px] tw-pb-[8px] tw-pr-[20px] tw-pl-[20px] tw-rounded-[100px] tw-text-center tw-text-[#387DFF] !tw-no-underline tw-text-[13px] tw-font-[500] tw-font-[Poppins] add-item-button`" }
const _hoisted_32 = {
  key: 2,
  class: "tw-flex tw-gap-[20px]"
}

import {
  Ref,
  ref,
  computed,
  PropType,
  ComputedRef,
  onMounted,
  watch,
} from "vue";
import ToggleIcon from "../svgs/toggleIcon.vue";
import {
  TYPE_ASSESSMENT_VIEW_STYLE,
  assessmentQuestionVisibleState,
  assessmentAdditionalInfoType,
  CHECKLIST_TYPE,
  infomationRequiredId,
} from "@/utils/constants";
import PinIcon from "../svgs/pinIcon.vue";
import PenIcon from "../svgs/penIcon.vue";
import AssessmentQuestionPrefilledTag from "../assessment/assessmentQuestionPrefilledTag.vue";
import AssessmentQuestionNotApplicableTag from "../assessment/assessmentQuestionNotApplicableTag.vue";
import ExpandingButton from "../common/expandingButton.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import Button4 from "../common/button4.vue";
import store from "@/store";
import AssessmentAdditionalInfo from "./assessmentAdditionalInfo.vue";
import { useRoute } from "vue-router";
import { addItemFromMaster } from "@/services/assessment";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Handler } from "mitt";
import { Checklist } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentQuestionTextArea',
  props: {
  selectedQuestions: {
    type: Array as () => number[],
    default: () => [],
  },
  checklistItem: {
    type: Object,
    default: () => ({}),
  },
  viewStyle: {
    type: String as PropType<keyof typeof TYPE_ASSESSMENT_VIEW_STYLE>,
    default: TYPE_ASSESSMENT_VIEW_STYLE.user,
  },
  placeholder: {
    type: String,
    default: "",
  },
  isSelectedAll: {
    type: Boolean,
    default: false,
  },
  level: {
    type: Number,
    default: 1,
  },
  isVendorRequest: {
    type: String,
    default: "",
  },
  idx: {
    type: String,
    default: "",
  },
},
  emits: [
  "update:answer",
  "openEvidenceModal",
  "exclude",
  "update:selectedQuestions",
  "showModalAddNoteAssessment",
  "showAdvanceModal",
  "uploadFile",
  "openReset",
],
  setup(__props, { emit: emits }) {

const props = __props;



let setTimeOutRef: any = null;
const route = useRoute();
const onHover: Ref<boolean> = ref(true);
const isCollapsed: Ref<boolean> = ref(true);
const passkeyQuestion: Ref<string> = ref("");

const isSelected = computed(() => {
  return props.selectedQuestions.includes(
    checklistItemDataRaw.value.itemMasterId,
  );
});

watch(
  () => props.checklistItem,
  (value) => {
    answer.value = value.checklistItemNotes || "";
  },
);

const answerOriginal: Ref<string> = ref(props.checklistItem.checklistItemNotes);

const answer: Ref<string> = ref(props.checklistItem.checklistItemNotes || "");

const isExclude: Ref<boolean> = computed(() => {
  return (
    checklistItemDataRaw.value?.visibleState ===
    assessmentQuestionVisibleState.no
  );
});

const checklistItemDataRaw = computed(() => {
  return props.checklistItem;
});

const isCheckStatusInprogAndWait = computed(
  () => store.getters["Vendor/isCheckStatusInprogAndWait"],
);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => false);

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};


const showAdvanceModal = () => {
  emits("showAdvanceModal", passkeyQuestion.value);
};
const openEvidenceModal = () => {
  emits("openEvidenceModal", checklistItemDataRaw.value);
};

const showModalAddNoteAssessment = () => {
  emits("showModalAddNoteAssessment", checklistItemDataRaw.value);
};

onMounted(() => initial());

const initial = () => {
  EventEmitter.on(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, ((data: {
    password: string;
    checklistItemId: number;
  }) => {
    if (
      data.password &&
      data.checklistItemId === checklistItemDataRaw.value.checklistItemId
    ) {
      passkeyQuestion.value = data.password;
    }
  }) as Handler<unknown>);
};

const addItemAction = async () => {
  try {
    const activeCategoryId = store.getters["Assessment/getActiveCategory"];
    const res = await addItemFromMaster(
      Number(route.query.checklistId),
      [checklistItemDataRaw.value.checklistItemId],
      activeCategoryId,
    );
    if (res) {
      const params = {
        checklistIdParam: Number(route.query.checklistId),
        showMasterItem: true,
      };
      store.dispatch("Assessment/fetchChecklistByCategory", params);
    }
  } catch (error) {
    showErrorAPI(error, Checklist.addItemFromMaster);
  }
};

const isShowAdditionInfo = () => {
  return (
    !isExclude.value &&
    (!(
      checklistItemDataRaw.value?.visibleState ===
      assessmentQuestionVisibleState.prefilled
    ) ||
      !isCollapsed.value) &&
    ((checklistItemDataRaw.value.additionalData &&
      checklistItemDataRaw.value.additionalData.length > 0) ||
      (checklistItemDataRaw.value.checklistItemNotes &&
        checklistItemDataRaw.value.checklistItemNotes !== "null"))
  );
};

const handleSelectedQuestions = () => {
  if (isExclude.value || checklistItemDataRaw.value.checklistItemIsNa) return;
  emits("update:selectedQuestions", {
    item: checklistItemDataRaw.value,
    selected: isSelected.value,
    level: props.level,
  });
};

const handleUpdateValue = async () => {
  if (answerOriginal.value !== answer.value) {
    const result = await store.dispatch(
      "Vendor/updateVendorRequestedExternalInput",
      [
        {
          checklistRequestedItemId: checklistItemDataRaw.value.checklistItemId,
          notes: answer.value,
        },
      ],
    );

    if (result) answerOriginal.value = answer.value;
    else answer.value = answerOriginal.value;
  }
};

const handleResetAnswer = () => {
  emits("openReset", checklistItemDataRaw.value.checklistItemId);
};

const handleUpdateChecklitsItem = (isNa: boolean) => {
  emits("update:answer", [
    {
      checklistRequestedItemId: checklistItemDataRaw.value.checklistItemId,
      isNa,
    },
  ]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `assessment-question-text-area-${checklistItemDataRaw.value.checklistItemId}`,
    "data-cy": `assessment-question-attachment-${__props.idx}`,
    class: _normalizeClass(`tw-flex tw-flex-col md:tw-px-[25px] md:tw-py-[35px] tw-p-[10px] assessmentQuestion tw-text-[#231F20] tw-text-base tw-font-[Poppins]`),
    onMouseover: onHoverIn,
    onMouseout: onHoverOut
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ToggleIcon, {
              id: `assessment-question-text-area-toggle-${checklistItemDataRaw.value.checklistItemId}`,
              class: _normalizeClass(`${
                isExclude.value || checklistItemDataRaw.value.checklistItemIsNa
                  ? `tw-opacity-50`
                  : 'tw-cursor-pointer'
              }`),
              ticked: isSelected.value,
              color: "#387dff",
              onClick: handleSelectedQuestions
            }, null, 8, ["id", "class", "ticked"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).prefilled
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(AssessmentQuestionPrefilledTag, {
                    "number-question": '',
                    color: "green",
                    expand: !isCollapsed.value
                  }, null, 8, ["expand"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(`${
                    isExclude.value || checklistItemDataRaw.value.checklistItemIsNa
                      ? `greyed`
                      : ''
                  } tw-flex tw-items-center tw-text-[#231F20] tw-text-[16px] tw-not-italic tw-font-normal tw-leading-[normal]`)
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createElementVNode("span", {
                        id: `assessment-question-text-area-name-${checklistItemDataRaw.value.checklistItemId}`,
                        class: "tw-text-[#231F20] tw-text-base tw-font-[Poppins]",
                        "data-cy": "vendor-assessment-question-name",
                        "data-id": `${checklistItemDataRaw.value.checklistItemId}`
                      }, _toDisplayString(checklistItemDataRaw.value.checklistItemHeadingLabel ||
                          checklistItemDataRaw.value.checklistItemName) + " " + _toDisplayString(checklistItemDataRaw.value.subName
                            ? ` | ${checklistItemDataRaw.value.subName}`
                            : ""), 9, _hoisted_11)
                    ]),
                    (
                        (checklistItemDataRaw.value.checklistItemDescription ||
                          checklistItemDataRaw.value.checklistItemGuidance) &&
                        onHover.value
                      )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createVNode(ButtonShowDuplicateAssessment, {
                            "id-popover": `assessment-question-text-area-popover-duplicate-${checklistItemDataRaw.value.checklistItemId}`,
                            "custom-class": 'tw-w-[max-content] tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                            class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
                            classes: `!tw-leading-none tw-items-center tw-justify-center`
                          }, {
                            default: _withCtx(() => [
                              (!checklistItemDataRaw.value.checklistItemIsNa)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      (
                                checklistItemDataRaw.value.checklistItemDescription
                              )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(getComponentUiText)(
                                    "app-menu-submenu-assessments-further-information-1",
                                  )), 1),
                                            _createVNode(CustomDescriptionContent, {
                                              description: 
                                  checklistItemDataRaw.value.checklistItemDescription
                                ,
                                              class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                                            }, null, 8, ["description"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (checklistItemDataRaw.value.checklistItemGuidance)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(getComponentUiText)(
                                    "app-menu-submenu-assessments-guidance-1",
                                  )), 1),
                                            _createVNode(CustomDescriptionContent, {
                                              description: 
                                  checklistItemDataRaw.value.checklistItemGuidance
                                ,
                                              class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                                            }, null, 8, ["description"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["id-popover"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (checklistItemDataRaw.value.checklistItemIsNa)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(AssessmentQuestionNotApplicableTag, {
                        color: "grey",
                        expand: !isCollapsed.value
                      }, null, 8, ["expand"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (
                checklistItemDataRaw.value.checklistItemNotesOrgExternal &&
                checklistItemDataRaw.value?.checklistItemComplianceTypeValueOrgId ===
                  _unref(infomationRequiredId)
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", {
                    "data-cy": `further-information-required-note-${checklistItemDataRaw.value.checklistItemId}`
                  }, _toDisplayString(_unref(getComponentUiText)(
                    "app-vendor-assess-further-information-required-1",
                  )) + ": " + _toDisplayString(" ") + " " + _toDisplayString(checklistItemDataRaw.value.checklistItemNotesOrgExternal), 9, _hoisted_22)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              id: `assessment-question-text-area-editor-${checklistItemDataRaw.value.checklistItemId}`,
              "data-cy": "assessment-question-text-answer",
              class: _normalizeClass(`tw-max-w-[90%] lg:tw-max-w-[965px] ${
                checklistItemDataRaw.value.checklistItemIsNa
                  ? 'tw-pointer-events-none'
                  : ''
              }`)
            }, [
              _createVNode(WYSiwygEditor, {
                modelValue: answer.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answer).value = $event)),
                "include-image": false,
                "data-cy-id": "assessment-question-text-answer-input",
                "is-disabled": 
                  isChecklistCompleted.value || !isCheckStatusInprogAndWait.value
                ,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event) => (answer.value = $event)),
                "onUpdate:blur": handleUpdateValue
              }, null, 8, ["modelValue", "is-disabled"])
            ], 10, _hoisted_23),
            (
                isShowAdditionInfo() &&
                __props.isVendorRequest !== _unref(CHECKLIST_TYPE).externalChecklist
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistItemDataRaw.value.additionalData as any, ({ type, attachments, text, href }, index) => {
                    return (_openBlock(), _createBlock(AssessmentAdditionalInfo, {
                      id: `assessment-question-text-area-additional-${checklistItemDataRaw.value.checklistItemId}-${index}`,
                      key: index,
                      type: type,
                      attachments: attachments || [],
                      text: text ? text : '',
                      href: href ? href : '',
                      "checklist-item-id": checklistItemDataRaw.value.checklistItemId,
                      "is-hovered": onHover.value,
                      "passkey-question": passkeyQuestion.value,
                      onViewAttachments: openEvidenceModal,
                      onViewInfo: showModalAddNoteAssessment
                    }, null, 8, ["id", "type", "attachments", "text", "href", "checklist-item-id", "is-hovered", "passkey-question"]))
                  }), 128)),
                  (
                  checklistItemDataRaw.value.checklistItemNotes &&
                  checklistItemDataRaw.value.checklistItemNotes !== 'null'
                )
                    ? (_openBlock(), _createBlock(AssessmentAdditionalInfo, {
                        key: 0,
                        id: `assessment-question-text-area-additional-${checklistItemDataRaw.value.checklistItemId}`,
                        type: _unref(assessmentAdditionalInfoType).notes,
                        "note-text": checklistItemDataRaw.value.checklistItemNotes,
                        onViewAttachments: openEvidenceModal,
                        onViewInfo: showModalAddNoteAssessment
                      }, null, 8, ["id", "type", "note-text"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (
              checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).prefilled &&
              !checklistItemDataRaw.value.checklistItemIsNa
            )
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "tw-cursor-pointer tw-absolute md:tw-relative md:tw-top-[unset] tw-top-[22px] tw-right-[18px] arrow",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isCollapsed.value = !isCollapsed.value))
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "12",
                  height: "8",
                  viewBox: "0 0 12 8",
                  fill: "none",
                  style: _normalizeStyle(isCollapsed.value ? 'transform: rotate(180deg)' : '')
                }, _hoisted_28, 4))
              ]))
            : _createCommentVNode("", true),
          (
              !(
                checklistItemDataRaw.value?.visibleState ===
                _unref(assessmentQuestionVisibleState).prefilled
              ) || !isCollapsed.value
            )
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                (!isExclude.value && onHover.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                      (!checklistItemDataRaw.value.checklistItemIsNa)
                        ? (_openBlock(), _createBlock(ExpandingButton, {
                            key: 0,
                            id: `assessment-question-text-area-notes-${checklistItemDataRaw.value.checklistItemId}`,
                            color: "#387DFF",
                            icon: PenIcon,
                            text: 
                  _unref(getComponentUiText)(
                    'app-component-assessments-override-question-note-title-1',
                  )
                ,
                            onClick: showAdvanceModal
                          }, null, 8, ["id", "text"]))
                        : _createCommentVNode("", true),
                      (!checklistItemDataRaw.value.checklistItemIsNa)
                        ? (_openBlock(), _createBlock(ExpandingButton, {
                            key: 1,
                            id: `assessment-question-text-area-evidence-${checklistItemDataRaw.value.checklistItemId}`,
                            class: _normalizeClass(
                  isChecklistCompleted.value &&
                  checklistItemDataRaw.value.checklistItemAttachments?.length === 0
                    ? '!tw-transform-none'
                    : ''
                ),
                            color: 
                  isChecklistCompleted.value &&
                  checklistItemDataRaw.value.checklistItemAttachments?.length === 0
                    ? '#62a2f5'
                    : '#387DFF'
                ,
                            icon: PinIcon,
                            text: 
                  _unref(getComponentUiText)(
                    'app-component-assessments-evidence-button-title-1',
                  )
                ,
                            "max-width": "95px",
                            onClick: showAdvanceModal
                          }, null, 8, ["id", "class", "color", "text"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createVNode(ButtonShowMore, {
                          classes: `!tw-px-0`,
                          "id-popover": `assessment-question-text-area-popover-${checklistItemDataRaw.value.checklistItemId}`
                        }, {
                          default: _withCtx(() => [
                            (
                      __props.viewStyle !== _unref(TYPE_ASSESSMENT_VIEW_STYLE).vendor &&
                      !checklistItemDataRaw.value.checklistItemIsNa
                    )
                              ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                  key: 0,
                                  style: _normalizeStyle(`tw-self-center ${
                      isChecklistCompleted.value
                        ? '!tw-cursor-not-allowed normal'
                        : 'normal'
                    }`),
                                  "id-text": 'app-component-vendor-question-advance-option-1',
                                  "style-text": '!tw-self-auto',
                                  "id-popover": `assessment-question-text-area-popover-advance-${checklistItemDataRaw.value.checklistItemId}`,
                                  onClick: showAdvanceModal
                                }, null, 8, ["style", "id-popover"]))
                              : _createCommentVNode("", true),
                            (
                      isCheckStatusInprogAndWait.value &&
                      !checklistItemDataRaw.value.checklistItemIsNa
                    )
                              ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                  key: 1,
                                  style: _normalizeStyle(`tw-self-center ${
                      isChecklistCompleted.value
                        ? '!tw-cursor-not-allowed normal'
                        : 'normal'
                    }`),
                                  "id-text": 'app-component-assessments-question-bulk-action-item-reset-answer-1',
                                  "style-text": '!tw-self-auto',
                                  "id-popover": `assessment-question-text-area-popover-reset-answer-${checklistItemDataRaw.value.checklistItemId}`,
                                  onClick: handleResetAnswer
                                }, null, 8, ["style", "id-popover"]))
                              : _createCommentVNode("", true),
                            (!checklistItemDataRaw.value.checklistItemIsNa)
                              ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                  key: 2,
                                  style: _normalizeStyle(`tw-self-center ${
                      isChecklistCompleted.value
                        ? '!tw-cursor-not-allowed normal'
                        : 'normal'
                    }`),
                                  "id-text": 'app-component-assessments-question-bulk-action-item-not-applicable-1',
                                  "style-text": '!tw-self-auto',
                                  "id-popover": `assessment-question-text-area-popover-applicable-${checklistItemDataRaw.value.checklistItemId}`,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (handleUpdateChecklitsItem(true)))
                                }, null, 8, ["style", "id-popover"]))
                              : _createCommentVNode("", true),
                            (checklistItemDataRaw.value.checklistItemIsNa)
                              ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                  key: 3,
                                  style: _normalizeStyle(`tw-self-center ${
                      isChecklistCompleted.value
                        ? '!tw-cursor-not-allowed normal'
                        : 'normal'
                    }`),
                                  "id-text": 'app-component-assessments-question-bulk-action-item-answer-question-1',
                                  "style-text": '!tw-self-auto',
                                  "id-popover": `assessment-question-text-area-popover-answer-${checklistItemDataRaw.value.checklistItemId}`,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleUpdateChecklitsItem(false)))
                                }, null, 8, ["style", "id-popover"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["id-popover"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (checklistItemDataRaw.value.isMaster)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: addItemAction
                    }, [
                      _createElementVNode("button", _hoisted_31, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessments-assessment-button-add-item-1",
                  )), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                checklistItemDataRaw.value.itemCompleteValue !== undefined ||
                isExclude.value
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      (isExclude.value)
                        ? (_openBlock(), _createBlock(Button4, {
                            key: 0,
                            class: _normalizeClass(`tw-self-center ${
                  isChecklistCompleted.value ? '!tw-cursor-not-allowed' : ''
                }`),
                            "id-popover": `assessment-question-text-area-exclude-${checklistItemDataRaw.value.checklistItemId}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-component-assessments-include-1")), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "id-popover"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 40, _hoisted_1))
}
}

})